"use client";

// 2026-09-17 F-02 (RSC por defecto — research 2026: Next.js docs Server/Client
// Components + "No async Client Component"): isla hoja con el ÚNICO JS
// interactivo del footer (scroll suave en hash-links vía window.matchMedia +
// history.pushState). El shell del footer es server (Footer.tsx); esta isla
// recibe strings ya traducidas — props 100% serializables.

import Link from "next/link";

export interface FooterNavSection {
  title: string;
  links: {
    href: string;
    /** Ruta sin localizar para comparar pathname. */ raw: string;
    label: string;
  }[];
}

export function FooterNavLinks({ sections }: { sections: FooterNavSection[] }) {
  return (
    <>
      {sections.map((section) => (
        <nav key={section.title} aria-label={section.title}>
          <h2 className="footer-heading text-foreground font-semibold mb-4 text-sm">
            {section.title}
          </h2>
          <ul className="flex flex-col space-y-2.5" role="list">
            {section.links.map((link) => (
              <li key={link.href}>
                <Link
                  href={link.href}
                  className="footer-link link-underline text-sm text-muted-foreground hover:text-foreground transition-colors"
                  onClick={(e) => {
                    // Force in-page scroll for hash links (Next soft nav often skips it)
                    if (!link.raw.includes("#")) return;
                    const [path, hash] = link.raw.split("#");
                    if (!hash) return;
                    if (window.location.pathname === (path || "/")) {
                      e.preventDefault();
                      const el = document.getElementById(hash);
                      if (el) {
                        window.history.pushState(null, "", `#${hash}`);
                        const reduce = window.matchMedia(
                          "(prefers-reduced-motion: reduce)"
                        ).matches;
                        el.scrollIntoView({
                          behavior: reduce ? "auto" : "smooth",
                          block: "start",
                        });
                      } else {
                        window.location.hash = hash;
                      }
                    }
                  }}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </>
  );
}
